import { Component } from '@angular/core';

@Component({
  selector: 'app-molecular-info',
  templateUrl: './molecular-info.component.html',
  styleUrls: ['./molecular-info.component.scss']
})
export class MolecularInfoComponent {
  isExpandInfo: boolean = false;

  toggleExpandInfo() {
    this.isExpandInfo = !this.isExpandInfo;
  }

}
